export const provisionReportFilterAdapter = (filters) => ({
  numeroContrato: filters.numeroContrato.map((contrato) => contrato.label)
});

export const contractRespAdapter = (contract) =>
  contract.map((c) => ({ id: c.id, nombre: c.nroContrato }));
